// extracted by mini-css-extract-plugin
module.exports = {"dialogbox":"Comment_dialogbox__14Ao1","message":"Comment_message__1V-z7","date":"Comment_date__-TZpP","img":"Comment_img__1UXxZ"};